export enum EnvironmentState {
	Development,
	Staging,
	Production,
}
